namespace Areas.Maintenance.List {
    "use strict";

    var vendorInfoMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["PrincipalArchitect", "DesignProfessional", "Discipline", "DesignProfessionalDiscipline"]);

    var lookupsMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AttachmentType", "DrawingType", "Location", "MilestoneType", "ProjectType"]);

    var systemMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AuthorizedUser", "SystemConfigSettings", "SystemUsers"]);

    
    export function vendorInfoMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(vendorInfoMaintenanceTabItems)(params);
    }

    export function lookupsMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(lookupsMaintenanceTabItems)(params);
    }

    export function systemMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(systemMaintenanceTabItems)(params);
    }
}